import { render } from "./AdminDashboard.vue?vue&type=template&id=c54c8186&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"

import "./AdminDashboard.vue?vue&type=style&index=0&id=c54c8186&scoped=true&lang=css"
import "../../assets/css/staff-ticket-mobile.css?vue&type=style&index=1&id=c54c8186&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54c8186"]])

export default __exports__